import request from '@/utils/request'

//验证码
export function phoneCaptcha(phone) {
  return request({
    url: `/api/v1/hlj/hlj/phone/captcha/${phone}`,
    method: 'get',
  })
}
//登陆
export function login(data) {
  return request({
    url: '/api/v1/hlj/hlj/login',
    method: 'post',
    data:data
  })
}

//个人信息
export function info() {
  return request({
    url: `/api/v1/hlj/h5/hlj/info`,
    method: 'get',
    headers:{
      isToken:true
    }
  })
}

//个人信息修改
export function edit(data) {
  return request({
    url: '/api/v1/hlj/hlj/edit',
    method: 'post',
    data:data
  })
}

//图片上传
export function imageUpload(data) {
  return request({
    url: '/api/v1/hlj/honglingjin/oss/image/upload',
    method: 'post',
    data:data
  })
}
//视频上传
export function videoUpload(data) {
  return request({
    url: '/api/v1/hlj/honglingjin/oss/video/upload',
    method: 'post',
    data:data,
    timeout: 300 * 1000,
  })
}

//视频上传
export function radioUpload(data) {
  return request({
    url: '/api/v1/hlj/honglingjin/oss/radio/upload',
    method: 'post',
    data:data
  })
}

//分享接口
export function signature(data) {
  return request({
    // url: 'https://jshare.xhby.net/api/signature',
    url: 'https://jhd.xhby.net/share/api/v1/share/signature',
    method: 'post',
    data:data
  })
}

//劳动之家作品详情
export function labourhomeInfo(lhArticleId) {
  return request({
    url: `/api/v1/hlj/hlj/labourhome/info/${lhArticleId}`,
    method: 'get',
  })
}


//红领巾同参与 活动报名
export function activityApply(data) {
  return request({
    url: `/api/v1/hlj/hlj/activity/apply`,
    method: 'post',
    data:data
  })
}

//填写线下劳动证书领取方式
export function hljPmethod(data) {
  return request({
    url: `/api/v1/hlj/hlj/pmethod`,
    method: 'post',
    data:data
  })
}

//个人信息副本
export function hljPmethodInfo() {
  return request({
    url: `/api/v1/hlj/hlj/pmethod`,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js